var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "vehicle-content" },
    [
      _c("navigation"),
      _vm._v(" "),
      _vm.isUserProcessed
        ? _c("div", { staticClass: "vehicle-wrapper" }, [_c("router-view")], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }